module.exports = __webpack_public_path__ + "img/Condusef.37322715.svg";